import React, { useEffect, useState } from "react";
import ListHeader from "../../../components/listing/ListHeader";
import ListFooter from "../../../components/listing/ListFooter";
import DynamicTable from "../../../components/listing/DynamicTable";
import FiltroZona from "./FiltroZona";
import apiRoutes from "../../../api/apiRoutes";
import { appFetchJson } from "../../../utils/http";
import IconEdit from "../../../components/icons/IconEdit";
import IconTrash from "../../../components/icons/IconTrash";
import CrearZona from "./CrearZona";
import EditarZona from "./EditarZona";
import EliminarZona from "./EliminarZona";

export default function ListarZona() {
  const [porPagina, setPorPagina] = useState(30);
  const [pagina, setPagina] = useState(1);
  const [totalBackend, setTotalBackend] = useState(0);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [reloadKey, setReloadKey] = useState(0);
  const [mostrarCrear, setMostrarCrear] = useState(false);
  const [zonaAEditar, setZonaAEditar] = useState(null);
  const [zonaAEliminar, setZonaAEliminar] = useState(null);
  const [mostrarFiltros, setMostrarFiltros] = useState(false);
  const [filtros, setFiltros] = useState({ nombre: "" });

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const url = apiRoutes.zonas.listUrl({
          page: pagina - 1,
          size: porPagina,
          nombre: filtros.nombre.trim() || undefined,
        });
        const res = await appFetchJson(url);
        const items = Array.isArray(res?.items) ? res.items : [];
        setData(items);
        setTotalBackend(res?.totalElements ?? res?.total ?? items.length);
      } catch (e) {
        console.error("Error cargando zonas:", e);
        setError("Error al cargar las zonas.");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [pagina, porPagina, filtros, reloadKey]);

  const formatDate = (dateStr) => {
    if (!dateStr) return "—";
    const d = new Date(dateStr);
    return d.toLocaleDateString("es-PY", { day: "2-digit", month: "2-digit", year: "numeric" });
  };

  const columns = [
    {
      header: "Descripcion",
      accessor: "nombre",
      type: "text",
      width: "30%",
      cellClass: "font-medium text-gray-800 break-words",
    },
    
    {
      header: "Acción",
      type: "action",
      width: "10%",
      render: (row) => (
        <div className="flex justify-center items-center gap-2">
          <button title="Editar" onClick={() => setZonaAEditar(row)}>
            <IconEdit />
          </button>
          <button title="Eliminar" onClick={() => setZonaAEliminar(row)}>
            <IconTrash />
          </button>
        </div>
      ),
    },
  ];

  return (
    <div className="page">
      <ListHeader
        title="Zonas"
        filters={filtros}
        onFilterClick={() => setMostrarFiltros(true)}
        onClearFilters={() => { setFiltros({ nombre: "" }); setPagina(1); }}
        showAdd={true}
        addLabel="Agregar"
        onAddClick={() => setMostrarCrear(true)}
        pageSize={porPagina}
        onPageSizeChange={(size) => { setPorPagina(size); setPagina(1); }}
      />

      {loading && <div className="mt-2 text-sm text-gray-600">Cargando datos...</div>}
      {error && <div className="mt-2 text-sm text-red-600">{error}</div>}

      {mostrarFiltros && (
        <FiltroZona
          initialFilters={filtros}
          onSubmit={(nuevos) => { setFiltros(nuevos); setPagina(1); setMostrarFiltros(false); }}
          onClose={() => setMostrarFiltros(false)}
        />
      )}

      <DynamicTable size="S" data={data} columns={columns} />

      <ListFooter
        page={pagina}
        pageSize={porPagina}
        total={totalBackend}
        onPageChange={(p) => setPagina(p)}
      />

      {mostrarCrear && (
        <CrearZona
          onClose={() => setMostrarCrear(false)}
          onCreated={() => { setPagina(1); setReloadKey(k => k+1); setMostrarCrear(false); }}
        />
      )}

      {zonaAEditar && (
        <EditarZona
          initial={zonaAEditar}
          onClose={() => setZonaAEditar(null)}
          onSaved={() => { setReloadKey(k => k+1); setZonaAEditar(null); }}
        />
      )}

      {zonaAEliminar && (
        <div className="modal-backdrop" onClick={() => setZonaAEliminar(null)}>
          <div className="modal-panel-md" onClick={e => e.stopPropagation()}>
            <EliminarZona
              registro={zonaAEliminar}
              onClose={() => setZonaAEliminar(null)}
              onDeleted={() => { setReloadKey(k => k+1); setZonaAEliminar(null); }}
            />
          </div>
        </div>
      )}
    </div>
  );
}